import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, TextInput, type TextInputProps } from './Controls.tsx';

export function PasswordInput({ id: suppliedId, ...props }: Omit<TextInputProps, 'type'>) {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const generatedId = useId();
    const id = suppliedId ?? generatedId;
    return (
        <div className="space-y-2">
            <TextInput {...props} id={id} type={visible ? 'text' : 'password'} />
            <Button
                variant="light"
                size="xs"
                disabled={props.disabled}
                aria-controls={id}
                aria-pressed={visible}
                onClick={() => setVisible((value) => !value)}
            >
                {t('platform.ui.togglePassword')}
            </Button>
        </div>
    );
}
